import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export interface FileViewerState {
  isVisible: boolean;
  url: string | null;
  type: 'pdf' | 'image' | 'office' | 'unsupported' | null;
}

@Injectable({
  providedIn: 'root'
})
export class FileViewerService {
  private viewerState = new BehaviorSubject<FileViewerState>({ isVisible: false, url: null, type: null });
  viewerState$ = this.viewerState.asObservable();

  show(url: string, type: 'pdf' | 'image' | 'office' | 'unsupported' | null) {
    this.viewerState.next({ isVisible: true, url, type });
  }

  hide() {
    this.viewerState.next({ isVisible: false, url: null, type: null });
  }
}
